import Accordion from "@/components/Accordion";
import { LanguageConfigModel } from "@/pages/Messaging/types";
import React from "react";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export function Footer(props: Props) {
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};
  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };

  return (
    <Accordion.Item eventKey="footer" onExpanded={() => props.onExpanded()}>
      <Accordion.Header>
        <Accordion.Title>Footer</Accordion.Title>
        <Accordion.SubTitle>
          Link the privacy policy of your brand
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-6">
          <div className="text-sm font-medium mb-2">Title</div>
          <TextInput
            value={workingLanguageConfig.privacyTitle}
            setValue={(value) => updateLanguageConfig({ privacyTitle: value })}
            showEmojiButton={false}
            maxWordCount={15}
          />
          <div className="text-sm font-medium mb-2">Link</div>
          <TextInput
            value={workingLanguageConfig.privacyUrl}
            setValue={(value) => updateLanguageConfig({ privacyUrl: value })}
            showEmojiButton={false}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
